<template>
  <div
    id="helpPageModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="modal-title">{{ content.title }}</h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-html="content.content"></p>
          <div v-if="help.files.length > 0">
            <div class="filebtn">
              <a
                :href="file"
                target="_blank"
                class="btn btn-success"
                v-for="(file, i) in help.files[counter]"
                :key="i"
              >
                File {{ ++i }}</a
              >
            </div>
          </div>
          <div class="row" v-if="help.images.length > 0">
            <div
              class="hi-img col-12 col-lg-6"
              v-for="(item, key) in help.images[counter]"
              :key="key"
            >
              <img :src="item" class="w-100" alt="" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="counter < help.content.length - 1"
            type="button"
            class="btn btn-success"
            @click="next()"
          >
            Next
          </button>
          <button
            v-if="counter > 0"
            type="button"
            class="btn btn-primary"
            @click="prev()"
          >
            Prev
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "helpPageModal",
  props: ["help"],
  data() {
    return {
      content: {},
      counter: 0,
    };
  },
  methods: {
    next() {
      this.content = this.help.content[this.counter + 1];
      this.counter += 1;
    },
    prev() {
      this.content = this.help.content[this.counter - 1];
      this.counter -= 1;
    },
  },
  created() {
    this.content = this.help.content[0];
  },
};
</script>

<style lang="css" scoped>
.filebtn {
  display: flex;
  flex-wrap: wrap;
}
</style>
